import React, { useState, useEffect } from 'react'
import { MiniVoting } from 'components/miniVoting'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import './styles.scss'

interface Props {
  content: QuestionGroup
  articleId: string
  open: boolean
}

export const TypescriptComponent = ({ content, articleId }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const reDatawrapper = new RegExp(/https:[^ ]+datawrapper[^ ]+/, 'gmi')
  const reIframe = new RegExp(/<iframe.*<\/iframe>/, 'gmi')
  // const text = content.answer.replace(reDatawrapper, 'DATAWRAPPER')
  const paragraphs = content.answer.split('\n')

  return (
    <div className={`ui segment question-group ${isOpen ? 'open' : 'closed'}`}>
      <div
        className='group-header'
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        <div className='number'>{content.number}</div>
        <h4 className='ui header'>
          {content.question}
          {content.new === 'TRUE' ? <span className='new'>Nouveau</span> : ''}
        </h4>
        <i className={isOpen ? 'close' : 'down'} />
      </div>
      {isOpen && (
        <div>
          <div>
            {paragraphs.map((p, i) => {
              let pContent = null

              if (p.length > 0) {
                if (p.match(reDatawrapper)) {
                  pContent = (
                    <AutofitIFrame
                      aria-label='Interactive line chart'
                      src={p}
                    />
                  )
                } /* else if (p.match(reIframe)) {
                  const reIframeSrc = new RegExp(/src="([^"]+)/, 'gmi')
                  const iframeSrc = reIframeSrc.exec(p)[1]

                  pContent = (
                    <AutofitIFrame
                      aria-label='Interactive line chart'
                      src={iframeSrc}
                    />
                  )
                } */ else {
                  const text = p.replace(
                    "<%= customer::customer('url_hostname_only_really') %>",
                    parseHostname().publicationName
                  )

                  pContent = (
                    <p
                      dangerouslySetInnerHTML={{ __html: text }}
                      key={content.id + '-p-' + i}
                    />
                  )
                }
              }

              return pContent
            })}
          </div>
          {content.sources && (
            <small dangerouslySetInnerHTML={{ __html: content.sources }} />
          )}
          <MiniVoting
            locale='FR'
            elementId={content.id}
            articleID={articleId}
          />
        </div>
      )}
    </div>
  )
}
